/**
 * Header View
 */

define(function(require, exports, module) {
    'use strict';

    const $ = require('j');
    const core = require('core');
    const _ = require('underscore');
    const config = require('config');
    const urlUtil = require('util/url.util');
    const device = require('util/device.util');
    const BaseView = require('common/base.view');
    const historyUtil = require('util/history.util');
    const communicaitonApi = require('modules/api/communication.api');

    module.exports = BaseView.extend({
        events: {
            'tap a': 'handleLinkNavigate',
            'tap .fn-open-menu': 'openMenu',
            'tap .fn-login': 'openLoginPopup',
            'tap .fn-low-balance': 'openLowBalancePopup',
            'tap .fn-back-button': 'handleBackButtonTap',
            'tap .fn-open-inbox': 'handleOpenInbox',
            'tap .fn-show-sidebar': 'handleShowSideBarTap'
        },

        initialize: function(options) {
            this.setElement(options.el);
        },

        subscribe: function() {
            this.listenTo(this.model, {
                'change': this.render
            });

            this.listenTo(core, {
                'app:translationsLoaded': this.render,
                'navigate backButton:show': this.toggleBackButton,
                'page:refresh': this.render,
                'page:initialResourcesLoaded': this.render,
            });

            $.event.add(window, 'popstate.header', this.toggleBackButton.bind(this));
            $.event.add(window, 'orientationchange.header', this.handleOrientationChange.bind(this));
        },

        handleLinkNavigate: function(e) {
            e.preventDefault();

            var path = e.currentTarget.getAttribute('href') || e.currentTarget.dataset.url;
            var target = e.currentTarget.getAttribute('target');

            return core.navigate(path, { target: target });
        },

        render: function() {
            var themeName = config.get('themeName');
            var requestStamp = config.get('requestStamp');
            var isDesktop = this.model.get('isDesktopHeader');
            var menuWcId = config.get('page.menuWcId');
            var overrideMenu = config.get('page.overrideMenu');
            var customizationURLs = config.get('customization') || {};
            var hideInboxByUrl = urlUtil.getLocationParameterByName('hideInbox') === '1';
            var hideChatByUrl = urlUtil.getLocationParameterByName('hideChat') === '1';
            var search = new URLSearchParams(window.location.search);
            var casinoname = search.get('casinoname');
            var site = search.get('site');
            var params = new URLSearchParams({
                t: customizationURLs.siteLogoPath ? requestStamp : this.model.get('t')
            });

            if (casinoname) {
                params.set('casinoname', casinoname);
            }

            if (site) {
                params.set('site', site);
            }

            var logoURL = customizationURLs.siteLogoPath
                ? `${customizationURLs.siteLogoPath}?${params.toString()}`
                : `/${themeName}/images/logo.png??${params.toString()}`;
            var options = _.extend(this.model.toJSON(), {
                showInboxIcon: config.get('inboxWidget')
                    && config.get('inboxWidget').showIcon && config.get('inboxWidget').enabled && !hideInboxByUrl,
                showSessionTicker: config.get('showSessionTicker'),
                themeName: themeName,
                showChatIcon: !hideChatByUrl,
                logoURL: logoURL,
                hideBurgerMenuIcon: overrideMenu && !menuWcId
            });

            // is very important while multi rendering
            this.closeChildViews();

            this.$el.html(
                this.tmpl(isDesktop ? 'header.desktop' : 'header.main', options).replace()
            );

            this.toggleBackButton();

            return this;
        },

        /**
         * Show/hide back button
         * @return {Boolean} is back button shown
         */
        toggleBackButton: function() {
            var isShowBack = Boolean(
                urlUtil.getLocationParameterByName('back_url')
                || historyUtil.state && historyUtil.state.showBack
            );

            this.$('.fn-back-button').toggleClass('hidden', !isShowBack);
            this.$('.fn-open-menu').toggleClass('hidden', isShowBack);

            return isShowBack;
        },

        handleOrientationChange: function() {
            // redraw header in android (fix bug with not enough width after change orientation)
            var isNativeLenovo = device.browserName === 'androidNative'
                && device.alias === 'Lenovo_A850';

            var redrawDelay = 500;
            if (isNativeLenovo) {
                redrawDelay = 1000;
            }

            _.delay(this.redraw.bind(this, this.el, isNativeLenovo), redrawDelay);

        },

        /**
         * Open login popup
         * @param  {Event} e
         */
        openLoginPopup: function(e) {
            e.preventDefault();

            core.trigger('app:message', {
                ID: 'showLogin',
                data: {
                    afterLoginUrl: window.location.pathname
                }
            });
        },

        openLowBalancePopup: function(e) {
            e.preventDefault();

            var depositPage = config.get('depositPage');

            window.Playtech.API.popup.showPopup({
                articleId: config.get('lowBalanceAlertWcId'),
                buttons: [
                    {
                        text: 'playtech.mobile.system.deposit',
                        onClick: function() {
                            core.navigate(depositPage);
                            window.Playtech.API.popup.closePopups();
                        }
                    }
                ]
            });
        },

        /**
         * Open menu
         */
        openMenu: function() {
            core.trigger('menu:action:open');
        },

        handleBackButtonTap: function(e) {
            e.preventDefault();
            this.navigateBack();
        },

        navigateBack: function() {
            var locationUrl = new URL(window.location);
            var backURL = locationUrl.searchParams.get('back_url');

            window.Playtech.API.common.replace(locationUrl.pathname, undefined, { removeParams: ['back_url'] });

            if (!_.isEmpty(backURL)) {
                this.doNavigate(backURL);
            } else {
                window.history.back();
            }
        },

        doNavigate: function(path) {
            if (window.Playtech.API.common.isAllowedToRedirect(path)) {
                core.navigate(path);

                return;
            }

            this.toggleBackButton();
        },

        close: function() {
            BaseView.prototype.close.apply(this, arguments);

            $.event.remove(window, '.header');
        },

        closeChildViews: function() {
            // correctly close all replacers
            this.childViews.forEach(function(view) {
                view.close();
            });

            this.childViews = [];
        },

        handleOpenInbox: function(event) {
            event.preventDefault();

            var inbox = communicaitonApi('inbox');

            if (!inbox) {
                return;
            }

            var status = inbox('getWindowStatus') || {};

            if (!config.get('inboxWidget').enabled) {
                return;
            }

            if (status.close) {
                return inbox('showInboxTab');
            }

            if (status.hide) {
                communicaitonApi('chat') && communicaitonApi('chat')('minimize');

                return inbox('maximize');
            }
        },

        handleShowSideBarTap: function(event) {
            event.preventDefault();

            window.Playtech.API?.sidebar?.open?.();
        }
    });
});
